import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    DispersedSourceSolidIcon,
    ExpandMoreIcon,
    Typography,
    useTheme
} from '@methanesat/ui-components';
import { useSelector } from 'react-redux';
import { useTranslate } from '../../../../hooks';
import { selectMethaneProduct } from '../../../../reducers';
import { EmissionTitle } from './EmissionTitle';

export const getUnavailableAccordionId = (targetId: string) => `unavailable-dispersed-accordion-${targetId}`;

export const DataUnavailableAccordion = ({
    expanded,
    handleChange,
    targetId
}: {
    expanded?: boolean;
    handleChange: (id: string) => void;
    targetId: string;
}) => {
    const theme = useTheme();
    const t = useTranslate();
    const product = useSelector(selectMethaneProduct);
    const id = getUnavailableAccordionId(targetId);

    return (
        <Accordion
            key={id}
            expanded={expanded}
            onChange={() => {
                handleChange(id);
            }}
            data-testid={`${id}`}
            elevation={0}
            disableGutters
            sx={theme.mixins.emissionAccordion}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ padding: '0' }}>
                <EmissionTitle
                    emissionTypeLabel={t(`emissionsMapPage.mapModals.emissions.areaTitle.${product}`)}
                    Icon={
                        <DispersedSourceSolidIcon
                            iconColor={theme.palette.grey[500]}
                            striped={true}
                            sx={{ marginRight: 2 }}
                        />
                    }
                    emissionsHeadline={
                        <Typography variant="h6" data-testid={`unavailable-accordion-headline-${id}`}>
                            {t('emissionsMapPage.mapModals.dispersed.totalOnlyHeadline')}
                        </Typography>
                    }
                    data-testid={`unavailable-accordion-title-${id}`}
                />
            </AccordionSummary>

            <AccordionDetails>
                <Box marginBottom={1}>
                    <Typography variant="body1">
                        {t('emissionsMapPage.mapModals.dispersed.unavailableDescription')}
                    </Typography>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};
